export const TAIWAN_HOTEL_LIST = [
	'ximending',
	'NTU',
	'zhongshan',
	'kaohsiung',
	'kaohsiungStation',
	'hualien',
	'jiaoxi',
	'sanchong',
	'hushan',
];


// WEBPACK FOOTER //
// ./src/util/constants.js